import { useTranslation } from 'react-i18next';

import { Icon } from '@/shared/ui/atoms/Icon';
import './UpgradeBlock.styl';

/** Compact invitation to upgrade the plan, at the foot of the sidebar. */
export function UpgradeBlock() {
  const { t } = useTranslation(undefined, { keyPrefix: 'shell.upgrade' });
  return (
    <div className="w-upgrade">
      <div className="w-upgrade__body">
        <div className="w-upgrade__title">{t('title')}</div>
        <div className="w-upgrade__text">{t('short')}</div>
      </div>
      <button type="button" className="w-upgrade__cta" aria-label={t('cta')} title={t('cta')}>
        <Icon name="arrowUp" size={15} />
      </button>
    </div>
  );
}
